import { ReplyForm } from './../../../../../../back-office/Models/ReplyForm';
import { ServiceRequestService } from './../../../../../../dealer-system/Services/service-request.service';
import { Subscription } from 'rxjs';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { ServiceRequest } from 'src/app/back-office/Models/ServiceRequest';

// actionForm keys that are not user inputs of the form
const NON_INPUT_FIELDS = new Set(['id', 'extraField', 'extraFieldName', 'solutionStep', 'title']);

@Component({
  selector: 'app-dealer-reply-step-form',
  templateUrl: './dealer-reply-step-form.component.html',
  styleUrls: ['./dealer-reply-step-form.component.scss']
})
export class DealerReplyStepFormComponent implements OnInit, OnDestroy {
  @Input() Index;
  @Input() isActive;

  public request: ServiceRequest = new ServiceRequest();
  private readonly subscriptions: Subscription[] = [];
  public isValidForm = false;

  constructor(
    private readonly requestService: ServiceRequestService,
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        this.request.reply.replyItems = this.request.reply.replyItems.filter(item => !item.solutionStep.restricted);
        if (this.request.reply.replyItems[this.Index] && !this.request.reply.replyItems[this.Index].replyForm) {
          this.request.reply.replyItems[this.Index].replyForm = new ReplyForm();
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  validateForm() {
    const {solutionStep: {actionForm}, replyForm} = this.request.reply.replyItems[this.Index];
    const enabledFields = Object.keys(actionForm)
      .filter(field => actionForm[field] && !NON_INPUT_FIELDS.has(field));

    this.isValidForm = enabledFields.every(field => replyForm[field] != null && replyForm[field] !== '')
      && (!actionForm.email || !Validators.email({value: replyForm.email} as AbstractControl));
  }

  confirmStep() {
    const data = this.request.reply.replyItems[this.Index].replyForm;
    this.subscriptions.push(
      this.requestService.confirmStep({serviceRequest: this.request.id , replyItem: this.request.reply.replyItems[this.Index].id , data: data}).subscribe(res => {
        this.requestService.fetchServiceRequestComplete(this.request.id , false);
      })
    );
  }
}
